export const SortShipmentOptions = {
  PickupReferenceNumber: "PickupReferenceNumber",
  DeliveryReferenceNumber: "DeliveryReferenceNumber",
  BookingDate: "BookingDate",
  PickupDate: "PickupDate",
  EstimatedDeliveryDate: "EstimatedDeliveryDate",
  DeliveryDate: "DeliveryDate",
  PickupBusinessName: "PickupBusinessName",
  DeliveryBusinessName: "DeliveryBusinessName",
} as const;
export type SortShipmentOptions =
  (typeof SortShipmentOptions)[keyof typeof SortShipmentOptions];

export function descriptionForSortShipmentOption(
  option: SortShipmentOptions,
): string {
  switch (option) {
    case SortShipmentOptions.PickupReferenceNumber:
      return "Pickup Reference Number";
    case SortShipmentOptions.DeliveryReferenceNumber:
      return "Delivery Reference Number";
    case SortShipmentOptions.BookingDate:
      return "Booking Date";
    case SortShipmentOptions.PickupDate:
      return "Pickup Date";
    case SortShipmentOptions.EstimatedDeliveryDate:
      return "Earliest Delivery Date";
    case SortShipmentOptions.DeliveryDate:
      return "Delivery Date";
    case SortShipmentOptions.PickupBusinessName:
      return "Pickup Business Name";
    case SortShipmentOptions.DeliveryBusinessName:
      return "Delivery Business Name";
  }
}
